export function classes(...clss: string[]): string {
  return clss.join(' ')
}
